module.exports = __webpack_public_path__ + "static/media/homeworkhelper.34fefb9b.png";